import { useQuery } from "react-query";
import { PortfolioSensitivityApi } from "@iliotech/generated-api-v3";
import { API_BASE } from "../../constants/constants";

export const useApiAugmentedScenariosCoefficientsReport = (
  portfolioId: string,
  sliderValues: {
    price: number;
    volatility: number;
    fx: number;
    yield: number;
  },
  enabledCondition: boolean
) => {
  const api = new PortfolioSensitivityApi(undefined, `${API_BASE}/api`);
  return useQuery(
    [`values-for-coefficients`, { portfolioId }],
    () =>
      api.getValues(
        portfolioId,
        sliderValues?.price,
        sliderValues?.volatility,
        sliderValues?.yield,
        sliderValues?.fx
      ),
    {
      enabled:
        (enabledCondition &&
          !(
            sliderValues?.price === 0 &&
            sliderValues?.fx === 0 &&
            sliderValues?.volatility === 0 &&
            sliderValues?.yield === 0
          )) ??
        false,
    }
  );
};
